/**
 * @flow
 * Created by neo on 13.03.17.
 */
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { translate  } from 'react-i18next';
import FlightBookingRequest from '../../../Store/Booking/FlightBookingRequest';
import Settings from '../../../Store/Settings';

type Props = {
  booking: FlightBookingRequest,
  t: any,
};

@observer
export class PricePreview extends React.Component<Props> {

  render() {
    const { t } = this.props;
    return (
      <div className="pt-2 pb-2">
        <div className="lead text-center">{`${
          this.props.booking.actualPrice
        } ${this.props.booking.currency}`}</div>
        {this.props.booking.is_exclusive && this.props.booking.price ? (
          <div className="text-center text-muted">
            {t('statt {{price}}', { price: this.props.booking.price })}
          </div>
        ) : null}
      </div>
    );
  }
}

export default translate ()(PricePreview);



// WEBPACK FOOTER //
// ./src/App/Flight/View/Booking/PricePreview.js